var index_es_deferred = {};

function AsyncView () {};

AsyncView.load = function (url, view) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var data = void 0;
  if (url in index_es_deferred) {
    return index_es_deferred[url];
  }

  var $deferred = $.Deferred();

  index_es_deferred[url] = $deferred;

  if (options.hash) {
    data = sessionStorage.getItem(url);

    if (data) {
      var deserialized = JSON.parse(data);

      if (options.hash === deserialized.options.hash) {
        delete index_es_deferred[url];
        return $deferred.resolve(deserialized).promise();
      }
    }
  }

  // NOTE The $.ajax request has the cache option set to false.
  // This is to prevent certain browsers from returning cached
  // versions of the url we are requesting.
  // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
  $.ajax({
    url: url,
    cache: false,
    data: 'view=' + view,
    dataType: 'html',
    headers: {
      'cache-control': 'no-cache'
    },
    success: function success(response) {
      var el = document.createElement('div');
      el.innerHTML = response;

      var responseOptions = {};
      var optionsEl = el.querySelector('[data-options]');

      if (optionsEl && optionsEl.innerHTML) {
        responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
      }

      var htmls = el.querySelectorAll('[data-html]');

      var html = {};

      if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
        html = htmls[0].innerHTML;
      } else {
        for (var i = 0; i < htmls.length; i++) {
          html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
        }
      }

      if (options.hash) {
        try {
          sessionStorage.setItem(url, JSON.stringify({ options: responseOptions, html: html }));
        } catch (error) {
          console.error(error);
        }
      }

      delete index_es_deferred[url];
      return $deferred.resolve({ options: responseOptions, html: html });
    },
    error: function error() {
      delete index_es_deferred[url];
      return $deferred.reject();
    }

  });

  return $deferred.promise();
}


// Utility function
function Util () {};

/* 
	class manipulation functions
*/
Util.hasClass = function(el, className) {
	if (el.classList) return el.classList.contains(className);
	else return !!el.getAttribute('class').match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

Util.addClass = function(el, className) {
	var classList = className.split(' ');
 	if (el.classList) el.classList.add(classList[0]);
  else if (!Util.hasClass(el, classList[0])) el.setAttribute('class', el.getAttribute('class') +  " " + classList[0]);
 	if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function(el, className) {
	var classList = className.split(' ');
	if (el.classList) el.classList.remove(classList[0]);	
	else if(Util.hasClass(el, classList[0])) {
		var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
    el.setAttribute('class', el.getAttribute('class').replace(reg, ' '));
	}
	if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function(el, className, bool) {
	if(bool) Util.addClass(el, className);
	else Util.removeClass(el, className);
};

Util.setAttributes = function(el, attrs) {
  for(var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

/* 
  DOM manipulation
*/
Util.getChildrenByClassName = function(el, className) {
  var children = el.children,
    childrenByClass = [];
  for (var i = 0; i < el.children.length; i++) {
    if (Util.hasClass(el.children[i], className)) childrenByClass.push(el.children[i]);
  }
  return childrenByClass;
};

Util.is = function(elem, selector) {
  if(selector.nodeType){
    return elem === selector;
  }

  var qa = (typeof(selector) === 'string' ? document.querySelectorAll(selector) : selector),
    length = qa.length,
    returnArr = [];

  while(length--){
    if(qa[length] === elem){
      return true;
    }
  }

  return false;
};

/* 
	Animate height of an element
*/
Util.setHeight = function(start, to, element, duration, cb, timeFunction) {
	var change = to - start,
	    currentTime = null;

  var animateHeight = function(timestamp){  
    if (!currentTime) currentTime = timestamp;         
    var progress = timestamp - currentTime;
    if(progress > duration) progress = duration;
    var val = parseInt((progress/duration)*change + start);
    if(timeFunction) {
      val = Math[timeFunction](progress, start, to - start, duration);
    }
    element.style.height = val+"px";
    if(progress < duration) {
        window.requestAnimationFrame(animateHeight);
    } else {
    	if(cb) cb();
    }
  };
  
  //set the height of the element before starting animation -> fix bug on Safari
  element.style.height = start+"px";
  window.requestAnimationFrame(animateHeight);
};

/* 
	Smooth Scroll
*/

Util.scrollTo = function(final, duration, cb, scrollEl) {
  var element = scrollEl || window;
  var start = element.scrollTop || document.documentElement.scrollTop,
    currentTime = null;

  if(!scrollEl) start = window.scrollY || document.documentElement.scrollTop;
      
  var animateScroll = function(timestamp){
  	if (!currentTime) currentTime = timestamp;        
    var progress = timestamp - currentTime;
    if(progress > duration) progress = duration;
    var val = Math.easeInOutQuad(progress, start, final-start, duration);
    element.scrollTo(0, val);
    if(progress < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      cb && cb();
    }
  };

  window.requestAnimationFrame(animateScroll);
};

/* 
  Focus utility classes
*/

//Move focus to an element
Util.moveFocus = function (element) {
  if( !element ) element = document.getElementsByTagName("body")[0];
  element.focus();
  if (document.activeElement !== element) {
    element.setAttribute('tabindex','-1');
    element.focus();
  }
};

/* 
  Misc
*/

Util.getIndexInArray = function(array, el) {
  return Array.prototype.indexOf.call(array, el);
};

Util.cssSupports = function(property, value) {
  if('CSS' in window) {
    return CSS.supports(property, value);
  } else {
    var jsProperty = property.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase();});
    return jsProperty in document.body.style;
  }
};

// merge a set of user options into plugin defaults
// https://gomakethings.com/vanilla-javascript-version-of-jquery-extend/
Util.extend = function() {
  // Variables
  var extended = {};
  var deep = false;
  var i = 0;
  var length = arguments.length;

  // Check if a deep merge
  if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
    deep = arguments[0];
    i++;
  }

  // Merge the object into the extended object
  var merge = function (obj) {
    for ( var prop in obj ) {
      if ( Object.prototype.hasOwnProperty.call( obj, prop ) ) {
        // If deep merge and property is an object, merge properties
        if ( deep && Object.prototype.toString.call(obj[prop]) === '[object Object]' ) {
          extended[prop] = extend( true, extended[prop], obj[prop] );
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  };

  // Loop through each object and conduct a merge
  for ( ; i < length; i++ ) {
    var obj = arguments[i];
    merge(obj);
  }

  return extended;
};

// Check if Reduced Motion is enabled
Util.osHasReducedMotion = function() {
  if(!window.matchMedia) return false;
  var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
  if(matchMediaObj) return matchMediaObj.matches;
  return false; // return false if not supported
}; 

/* 
	Polyfills
*/
//Closest() method
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
		var el = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1); 
		return null;
	};
}

//Custom Event() constructor
if ( typeof window.CustomEvent !== "function" ) {

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}

/* 
	Animation curves
*/
Math.easeInOutQuad = function (t, b, c, d) {
	t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
};

Math.easeInQuart = function (t, b, c, d) {
	t /= d;
	return c*t*t*t*t + b;
};

Math.easeOutQuart = function (t, b, c, d) { 
  t /= d;
	t--;
	return -c * (t*t*t*t - 1) + b;
};

Math.easeInOutQuart = function (t, b, c, d) {
	t /= d/2;
	if (t < 1) return c/2*t*t*t*t + b;
	t -= 2;
	return -c/2 * (t*t*t*t - 2) + b;
};

Math.easeOutElastic = function (t, b, c, d) {
  var s=1.70158;var p=d*0.7;var a=c;
  if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
  if (a < Math.abs(c)) { a=c; var s=p/4; }
  else var s = p/(2*Math.PI) * Math.asin (c/a);
  return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
};


/* JS Utility Classes */

// make focus ring visible only for keyboard navigation (i.e., tab key) 
(function() {
  var focusTab = document.getElementsByClassName('js-tab-focus'),
    shouldInit = false,
    outlineStyle = false,
    eventDetected = false;

  function detectClick() {
    if(focusTab.length > 0) {
      resetFocusStyle(false);
      window.addEventListener('keydown', detectTab);
    }
    window.removeEventListener('mousedown', detectClick);
    outlineStyle = false;
    eventDetected = true;
  };

  function detectTab(event) {
    if(event.keyCode !== 9) return;
    resetFocusStyle(true);
    window.removeEventListener('keydown', detectTab);
    window.addEventListener('mousedown', detectClick);
    outlineStyle = true;
  };

  function resetFocusStyle(bool) {
    var outlineStyle = bool ? '' : 'none';
    for(var i = 0; i < focusTab.length; i++) {
      focusTab[i].style.setProperty('outline', outlineStyle);
    }
  };

  function initFocusTabs() {
    if(shouldInit) {
      if(eventDetected) resetFocusStyle(outlineStyle);
      return;
    }
    shouldInit = focusTab.length > 0;
    window.addEventListener('mousedown', detectClick);
  };

  initFocusTabs();
  window.addEventListener('initFocusTabs', initFocusTabs);
}());

function resetFocusTabsStyle() {
  window.dispatchEvent(new CustomEvent('initFocusTabs'));
};

(function() {
  var Drawer = function(element) {
    this.element = element;
    this.content = document.getElementsByClassName('js-drawer__body')[0];
    this.triggers = document.querySelectorAll('[aria-controls="'+this.element.getAttribute('id')+'"]');
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.selectedTrigger = null;
    this.isModal = Util.hasClass(this.element, 'js-drawer--modal');
    this.showClass = "drawer--is-visible";
    this.initDrawer();
  };

  Drawer.prototype.initDrawer = function() {
    var self = this;
    //open drawer when clicking on trigger buttons
    if ( this.triggers ) {
      for(var i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener('click', function(event) {
          event.preventDefault();
          if(Util.hasClass(self.element, self.showClass)) {
            self.closeDrawer(event.target);
            return;
          }
          self.selectedTrigger = event.target;
          self.showDrawer();
          self.initDrawerEvents();
        });
      }
    }

    // if drawer is already open -> we should initialize the drawer events
    if(Util.hasClass(this.element, this.showClass)) this.initDrawerEvents();
  };

  Drawer.prototype.showDrawer = function() {
    var self = this;
    this.content.scrollTop = 0;
    Util.addClass(this.element, this.showClass);
    document.querySelector('body').classList.add('drawer-open');
    this.getFocusableElements();
    Util.moveFocus(this.element);
    // wait for the end of transitions before moving focus
    this.element.addEventListener("transitionend", function cb(event) {
      Util.moveFocus(self.element);
      self.element.removeEventListener("transitionend", cb);
    });
    this.emitDrawerEvents('drawerIsOpen', this.selectedTrigger);
  };

  Drawer.prototype.closeDrawer = function(target) {
    document.querySelector('body').classList.remove('drawer-open');
    Util.removeClass(this.element, this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    if(this.selectedTrigger) this.selectedTrigger.focus();
    //remove listeners
    this.cancelDrawerEvents();
    this.emitDrawerEvents('drawerIsClose', target);
  };

  Drawer.prototype.initDrawerEvents = function() {
    //add event listeners
    this.element.addEventListener('keydown', this);
    this.element.addEventListener('click', this);
  };

  Drawer.prototype.cancelDrawerEvents = function() {
    //remove event listeners
    this.element.removeEventListener('keydown', this);
    this.element.removeEventListener('click', this);
  };

  Drawer.prototype.handleEvent = function (event) {
    switch(event.type) {
      case 'click': {
        this.initClick(event);
      }
      case 'keydown': {
        this.initKeyDown(event);
      }
    }
  };

  Drawer.prototype.initKeyDown = function(event) {
    if( event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape' ) {
      //close drawer window on esc
      this.closeDrawer(false);
    } else if( this.isModal && (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab' )) {
      //trap focus inside drawer
      this.trapFocus(event);
    }
  };

  Drawer.prototype.initClick = function(event) {
    //close drawer when clicking on close button or drawer bg layer 
    if( !event.target.closest('.js-drawer__close') && !Util.hasClass(event.target, 'js-drawer') ) return;
    event.preventDefault();
    this.closeDrawer(event.target);
  };

  Drawer.prototype.trapFocus = function(event) {
    if( this.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of drawer
      event.preventDefault();
      this.lastFocusable.focus();
    }
    if( this.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of drawer
      event.preventDefault();
      this.firstFocusable.focus();
    }
  }

  Drawer.prototype.getFocusableElements = function() {
    //get all focusable elements inside the drawer
    var allFocusable = this.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
  };

  Drawer.prototype.getFirstVisible = function(elements) {
    //get first visible focusable element inside the drawer
    for(var i = 0; i < elements.length; i++) {
      if( elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length ) {
        this.firstFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.getLastVisible = function(elements) {
    //get last visible focusable element inside the drawer
    for(var i = elements.length - 1; i >= 0; i--) {
      if( elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length ) {
        this.lastFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.emitDrawerEvents = function(eventName, target) {
    var event = new CustomEvent(eventName, {detail: target});
    this.element.dispatchEvent(event);
  };

  //initialize the Drawer objects
  var drawer = document.getElementsByClassName('js-drawer');
  if( drawer.length > 0 ) {
    for( var i = 0; i < drawer.length; i++) {
      (function(i){new Drawer(drawer[i]);})(i);
    }
  }
}());

Accordion = (function() {
  function Accordion() {
    jQuery('.accordion.headings').each(function() {
      return jQuery(this).add(jQuery(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
    });
    general_scroll_to_active_item = false;

    jQuery('.accordion.headings li').wrapInner('<div class="trigger"></div>');
    jQuery('.accordion-wrapper').each(function() {
      var accordion_content, accordion_heading;
      accordion_heading = jQuery(this).find('.accordion.headings > li');
      accordion_content = jQuery(this).find('.accordion.content > li');
      //accordion_heading.first().addClass('active');
      accordion_content.each(function(index) {
        var content;
        content = jQuery('<div class="content">' + jQuery(this).html() + '</div>');
        return content.appendTo(accordion_heading.eq(index));
      });
      accordion_content.remove();
      //jQuery(this).find('.content').first().show();
      return jQuery(this).find('.trigger').on("click", function() {
        if( $(this).parent().hasClass('active') ) {

          jQuery(this).find('.toggle-icon').text('+').removeClass('minus-sign').addClass('plus-sign');

          var panels, this_panel;
          panels = jQuery(this).closest(".accordion").find('.content');
          this_panel = jQuery(this).closest("li").find(".content");
          this_panel.slideUp(200);

          return jQuery(this).closest("li").removeClass("active");

        } else {
          jQuery('.toggle-icon').text('+').addClass('plus-sign').removeClass('minus-sign');
          jQuery(this).find('.toggle-icon').text('-').removeClass('plus-sign').addClass('minus-sign');

          var panels, this_panel;
          panels = jQuery(this).closest(".accordion").find('.content');
          this_panel = jQuery(this).closest("li").find(".content");
          panels.not(this_panel).slideUp(200);
          this_panel.slideDown(200, function() {
            if (general_scroll_to_active_item) {
              return jQuery('html, body').animate({
                scrollTop: this_panel.offset().top - 100
              });
            }
          });
          jQuery(this).closest(".accordion").find("li").removeClass("active");
          return jQuery(this).closest("li").addClass("active");
        }
      });
    });
  }

  return Accordion;

})();

function removeItem(lineItem) {
  var $item = $("[data-cart-mini-item=\"".concat(lineItem, "\"]"));
  var url = "".concat(window.Theme.routes.cart_change_url, ".js");
  $item.addClass('cart-mini-item-loading');
  $item.parents('.drawer__body').addClass('cart-loading');
  $.post(url, {
    id: lineItem,
    quantity: 0
  }, function () {
    if (document.querySelector('[data-section-id="static-cart"]')) {
      // If we remove an item from minicart while on the cart page,
      // refresh the page to sync cart items on page
      window.location = "".concat(window.Theme.routes.cart_url);
    } else {
      $item.parents('.drawer__body').removeClass('cart-loading');
      refreshCart();
    }
  }, 'json');
}

function toggleDrawer() {
  var btn = document.getElementsByClassName('btn-open-drawer')[0];
  btn.click();
}

function refreshCart(openDrawer = false, refreshRelated = true) {
  var cart = document.querySelector('[data-cart-mini]');
  var content = cart.querySelector('[data-cart-mini-content]');
  var footer = cart.querySelector('[data-cart-mini-footer]');
  var shipping = cart.querySelector('[data-cart-mini-shipping]');
  var related = cart.querySelector('[data-cart-mini-related]');

  $('.drawer__body').addClass('cart-loading');

  var $deferred = $.Deferred();
  var jsonUrl = "".concat(window.Theme.routes.cart_url, ".js");
  var $deferred1 = $.get(jsonUrl, function (data) {
    return $('.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count').text(data.item_count === 0 ? '' : data.item_count);
  }, 'json');
  var $deferred2 = AsyncView.load(window.Theme.routes.cart_url, 'mini').done(function (data) {
    content.innerHTML = data.html.content;
    footer.innerHTML = data.html.footer;
    shipping.innerHTML = data.html.shipping;
    if(refreshRelated) related.innerHTML = data.html.related;

    $('.drawer__body').removeClass('cart-loading');

    if(openDrawer) {
      toggleDrawer();
    }
    
    $('[data-cart-mini-item-remove]').on('click.cart-mini', function (event) {
      removeItem(event.currentTarget.getAttribute('data-cart-mini-item-remove'));
    });

    return $deferred.resolve();
  }).fail($deferred.reject());
  return $.when($deferred1, $deferred2);
}

var checkout_url = '/checkout';
function reChargeProcessCart() {
  function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
  do {
    token=get_cookie('cart');
  }
  while(token == undefined);	
	var myshopify_domain=window.Theme.routes.permanent_domain;
  try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
  checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&discount=LOYALTY10";
}

var cart_has_subscription = false;
$('body').on('click', '.cart-mini-actions__checkout-button', function(e){
  e.preventDefault();
  
  var jsonUrl = "".concat(window.Theme.routes.cart_url, ".js");
  $.get(jsonUrl, function (data) {
    $.each(data.items, function(index, cartItem) {
      var properties = cartItem.properties;
      $.each(properties, function(key, value) {
        if(key == 'subscription_id') {
          cart_has_subscription = true;
        }
      });
    });
    
    if(cart_has_subscription) {
      reChargeProcessCart();
    }

    window.location.href = checkout_url;
  }, 'json');
   
});
  
$('body').on('click', '.related-item__add-to-cart', function(e){
  e.preventDefault();
  var text = $(this).val();
  $(this).val('Adding...');
  var key = $(this).siblings('input[name="id"]').val();
  var quantity = 1;

  $(this).parents('.drawer__body').addClass('cart-loading');
  var elem = $(this);

  $.ajax({
    type: 'POST',
    url: "".concat(window.Theme.routes.cart_add_url, ".js"),
    dataType: 'json',
    data: {
      quantity: quantity,
      id: key
    },
    success: function success(cart) {
      refreshCart(false, false);
      elem.val(text);

      if($('body').hasClass('template-cart')) {
        location.reload();
      }
    }
  });
});

$('body').on('change', '.cart-mini-qty-input', function(e){
  $(this).parents('.drawer__body').addClass('cart-loading');
  var key = $(this).parents('.cart-mini-item').data('cart-mini-item');
  var quantity = $(this).val();

  // debo hacer update y al final refresh

  $.ajax({
    type: 'POST',
    url: "".concat(window.Theme.routes.cart_change_url, ".js"),
    dataType: 'json',
    data: {
      quantity: quantity,
      id: key
    },
    success: function success(cart) {
      refreshCart();
    }
  });
});

$(document).ready(function() {

  refreshCart();

  document.getElementsByClassName('drawer-backdrop')[0].addEventListener('click', toggleDrawer);


  $('body').on('addToCartClicked', function(){
    refreshCart(true);
  });

  if($('#faqs').length > 0 ||
    $('#faq').length > 0) {
      new Accordion();
  }

  if($('.productAccordion').length > 0 ) {
    new Accordion();
  }

  if( $('.gift-legend').length > 0 ) {
    $('.gift-legend').detach().appendTo('.selectors').show();
  }

  $('.product-form .single-option-selector-product').on('change', function(e) {
    var value = this.value;
    if(value == '5.7 OZ'){
      $('.subscription-widget').addClass('d-none');
      $('input[name="purchase_type"][value="onetime"]').click();
    } else {
      $('.subscription-widget').removeClass('d-none');
      
    }
  });
  
  const observer = new MutationObserver(() => {
  	if (document.querySelector('#rc_price_autodeliver')) {
    	let autodeliver_price = document.getElementById('rc_price_autodeliver').innerHTML;
    	if(autodeliver_price != '') {
      		autodeliver_price = autodeliver_price.replace('$', '');
            autodeliver_price = parseFloat(autodeliver_price);
            let price_discount = autodeliver_price * 0.90;
            document.getElementById('rc_price_subscription').innerHTML = '$' + price_discount.toFixed(2);
        }
      }
    });

	observer.observe(document.body, {
      childList: true,
      subtree: false,
      characterData: true
    });
  
});

// Scroll to top button
const scrollTopButton = document.querySelector('[data-scroll-top-button]');
if (scrollTopButton) {
  scrollTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
  document.addEventListener('scroll', () => {
    scrollTopButton.classList.toggle('is-visible', window.pageYOffset > window.innerHeight);
  });
}

/* const _timeout = setTimeout(updatePrice, 5000);

                    function updatePrice() {
                      let autodeliver_price = document.getElementById('rc_price_autodeliver');
                      console.log(autodeliver_price);
                      /*if(autodeliver_price) {
                        console.log(autodeliver_price.innerHTML);
                        if(autodeliver_price.innerHTML !== '') {
                          console.log(autodeliver_price.innerHTM);
                          let price_discount = autodeliver_price.innerHTML * 1.01;
                          document.getElementById('rc_price_subscription').innerHTML = price_discount;
                          clearTimeout(_timeout);
                        }
                      }
                    }*/